<!-- Auth Modal Overlay -->
<div *ngIf="isOpen" class="fixed inset-0 z-[100] flex items-center justify-center p-3 sm:p-6">
  <!-- Backdrop -->
  <div class="absolute inset-0 bg-black/40" (click)="close()"></div>

  <!-- Modal Container -->
  <div class="relative bg-white w-full max-w-[92vw] sm:max-w-[480px] rounded-2xl shadow-2xl z-10" style="font-family: sans-serif;">
    <!-- Close button -->
    <button (click)="close()" class="absolute top-2.5 right-2.5 z-20 w-7 h-7 flex items-center justify-center rounded-full bg-[#e85d04] hover:bg-[#d45203] text-white transition-all shadow-md">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>

    <!-- Error / Success Messages -->
    <div *ngIf="errorMsg" class="mx-7 sm:mx-10 mt-4 px-3 py-2 bg-red-50 border border-red-200 rounded-lg text-red-600 text-xs">{{ errorMsg }}</div>
    <div *ngIf="successMsg" class="mx-7 sm:mx-10 mt-4 px-3 py-2 bg-green-50 border border-green-200 rounded-lg text-green-600 text-xs">{{ successMsg }}</div>

    <!-- LOGIN FORM -->
    <div *ngIf="authMode === 'login'" class="px-7 sm:px-10 py-8 sm:py-10" [class.pt-2]="errorMsg || successMsg">
      <h2 class="text-2xl font-bold text-center leading-tight mb-0.5" style="font-family: 'Roboto Slab', serif;">Welcome to</h2>
      <h2 class="text-2xl font-bold text-center text-[#600b0b] mb-4" style="font-family: 'Roboto Slab', serif;">Mahattaart</h2>

      <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="space-y-3 max-w-[320px] mx-auto w-full">
        <!-- Phone Number -->
        <div>
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors">
            <span class="pl-3.5 pr-1 text-sm text-gray-500 font-medium shrink-0">+91</span>
            <input formControlName="phone" type="tel" placeholder="Phone Number"
              class="w-full py-2.5 pr-3.5 pl-1 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="loginForm.get('phone')?.touched && loginForm.get('phone')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Valid 10-digit phone required</div>
        </div>

        <!-- OTP + Send OTP -->
        <div class="flex items-center gap-2">
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors" style="flex: 0 0 auto; width: 130px;">
            <span class="pl-3 pr-1 shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/></svg>
            </span>
            <input formControlName="otp" type="text" placeholder="OTP" maxlength="6"
              class="w-full py-2.5 pr-2.5 text-sm outline-none bg-transparent" />
          </div>
          <button type="button" (click)="sendOtp('login')"
            [disabled]="otpLoading || !loginForm.get('phone')?.value || loginForm.get('phone')?.invalid"
            [class]="'shrink-0 text-xs font-semibold px-4 py-2.5 rounded-full transition-colors disabled:opacity-50 ' +
              (loginForm.get('phone')?.valid && loginForm.get('phone')?.value ? 'bg-[#600b0b] hover:bg-[#4a0808] text-white' : 'bg-gray-200 text-gray-400 cursor-not-allowed')">
            {{ otpLoading ? 'Sending...' : (otpSent ? 'Resend' : 'Send OTP') }}
          </button>
        </div>

        <!-- OR divider -->
        <!-- <div class="flex items-center gap-3">
          <div class="flex-1 h-px bg-gray-200"></div>
          <span class="text-xs text-gray-400 font-medium">OR</span>
          <div class="flex-1 h-px bg-gray-200"></div>
        </div> -->

        <!-- Email -->
        <!-- <div class="relative">
          <label class="absolute -top-2 left-3.5 bg-white px-1 text-[10px] text-gray-400">Email</label>
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors">
            <span class="pl-3.5 pr-1.5 shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22,4 12,13 2,4"/></svg>
            </span>
            <input formControlName="email" type="email" placeholder="your@email.com"
              class="w-full py-2.5 pr-3.5 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Valid email required</div>
        </div> -->

        <!-- Password -->
        <!-- <div class="relative">
          <label class="absolute -top-2 left-3.5 bg-white px-1 text-[10px] text-gray-400">Password</label>
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors">
            <span class="pl-3.5 pr-1.5 shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            </span>
            <input formControlName="password" type="password" placeholder="Password"
              class="w-full py-2.5 pr-3.5 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Min 6 characters required</div>
        </div> -->

        <!-- Forgot Password -->
        <!-- <div class="text-center pt-0.5">
          <button type="button" (click)="switchToForgot()" class="text-xs text-[#600b0b] hover:underline font-medium">Forgot Password ?</button>
        </div> -->

        <!-- Sign In Button -->
        <button type="submit" [disabled]="loading"
          class="w-full bg-[#600b0b] hover:bg-[#4a0808] text-white font-bold py-2.5 rounded-full text-sm tracking-wide transition-all active:scale-[0.98] shadow-lg disabled:opacity-50">
          {{ loading ? 'Signing In...' : 'Sign In' }}
        </button>

        <!-- Switch to Signup -->
        <p class="text-center text-[14px] text-[#600b0b]">
          Don't have Account?
          <button type="button" (click)="switchToSignup()" class="hover:underline font-semibold ml-0.5">Sign Up</button>
        </p>
      </form>
    </div>

    <!-- FORGOT PASSWORD FORM -->
    <div *ngIf="authMode === 'forgot'" class="px-7 sm:px-10 py-8 sm:py-10" [class.pt-2]="errorMsg || successMsg">
      <h2 class="text-xl font-bold mb-5" style="font-family: 'Roboto Slab', serif;">Forgot Password</h2>

      <form [formGroup]="forgotForm" (ngSubmit)="onForgotPassword()" class="space-y-4 max-w-[320px] w-full">
        <!-- Email -->
        <div class="relative">
          <label class="absolute -top-2 left-3.5 bg-white px-1 text-[10px] text-[#600b0b] font-medium z-10">Email *</label>
          <div class="flex items-center border-2 border-[#600b0b] rounded-full overflow-hidden">
            <span class="pl-3.5 pr-1.5 shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="22,4 12,13 2,4"/></svg>
            </span>
            <input formControlName="email" type="email" placeholder="Email"
              class="w-full py-2.5 pr-3.5 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="forgotForm.get('email')?.touched && forgotForm.get('email')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Valid email required</div>
        </div>

        <!-- Send Mail Button -->
        <div class="flex justify-center">
          <button type="submit" [disabled]="loading"
            class="bg-[#600b0b] hover:bg-[#4a0808] text-white font-bold py-2.5 px-8 rounded-full text-sm tracking-wide transition-all active:scale-[0.98] shadow-lg disabled:opacity-50">
            {{ loading ? 'Sending...' : 'Send Mail' }}
          </button>
        </div>

        <!-- Back to Login -->
        <div class="text-center">
          <button type="button" (click)="switchToLogin()" class="text-xs text-[#600b0b] hover:underline font-medium">Back to Sign In</button>
        </div>
      </form>
    </div>

    <!-- SIGNUP FORM -->
    <div *ngIf="authMode === 'signup'" class="px-7 sm:px-10 py-7 sm:py-8" [class.pt-2]="errorMsg || successMsg">
      <h2 class="text-2xl font-bold text-center my-3" style="font-family: 'Roboto Slab', serif;">Sign Up</h2>
      <!-- <p class="text-center text-xs text-gray-500 mb-3">Get 5% additional off on your first order</p> -->

      <form [formGroup]="signupForm" (ngSubmit)="onSignup()" class="space-y-3 max-w-[320px] mx-auto w-full">
        <!-- Name -->
        <div>
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors">
            <input formControlName="fullName" type="text" placeholder="Name *"
              class="w-full py-2.5 px-4 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="signupForm.get('fullName')?.touched && signupForm.get('fullName')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Name is required</div>
        </div>

        <!-- Phone Number -->
        <div>
          <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors">
            <span class="pl-3.5 pr-1 text-sm text-gray-500 font-medium shrink-0">+91</span>
            <input formControlName="phone" type="tel" placeholder="Phone Number *"
              class="w-full py-2.5 pr-3.5 pl-1 text-sm outline-none bg-transparent" />
          </div>
          <div *ngIf="signupForm.get('phone')?.touched && signupForm.get('phone')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Valid 10-digit phone required</div>
        </div>

        <!-- OTP + Send OTP -->
        <div>
          <div class="flex items-center gap-2">
            <div class="flex items-center border border-gray-300 rounded-full overflow-hidden focus-within:border-[#600b0b] transition-colors" style="flex: 0 0 auto; width: 130px;">
              <input formControlName="otp" type="text" placeholder="6-digit OTP" maxlength="6"
                class="w-full py-2.5 px-3.5 text-sm outline-none bg-transparent" />
            </div>
            <button type="button" (click)="sendOtp('signup')"
              [disabled]="otpLoading || !signupForm.get('phone')?.value || signupForm.get('phone')?.invalid"
              [class]="'shrink-0 text-xs font-semibold px-4 py-2.5 rounded-full transition-colors disabled:opacity-50 ' +
                (signupForm.get('phone')?.valid && signupForm.get('phone')?.value ? 'bg-[#600b0b] hover:bg-[#4a0808] text-white' : 'bg-gray-200 text-gray-400 cursor-not-allowed')">
              {{ otpLoading ? 'Sending...' : (otpSent ? 'Resend' : 'Send OTP') }}
            </button>
          </div>
          <div *ngIf="signupForm.get('otp')?.touched && signupForm.get('otp')?.invalid" class="text-red-500 text-[11px] mt-0.5 ml-3.5">Enter valid 6-digit OTP</div>
        </div>

        <!-- Sign Up Button -->
        <button type="submit" [disabled]="loading"
          class="w-full bg-[#600b0b] hover:bg-[#4a0808] text-white font-bold py-2.5 rounded-full text-sm tracking-wide transition-all active:scale-[0.98] shadow-lg disabled:opacity-50">
          {{ loading ? 'Signing Up...' : 'Sign Up' }}
        </button>

        <!-- Switch to Login -->
        <p class="text-center text-[14px] text-gray-500 pb-1">
          Already have an Account?
          <button type="button" (click)="switchToLogin()" class="text-[#600b0b] hover:underline font-semibold ml-0.5">Sign In</button>
        </p>
      </form>
    </div>
  </div>
</div>
